import React, {useState, useEffect, useCallback, useContext} from 'react';
import {connect} from 'react-redux';
import QuickActionsCard from './QuickActionsCard';
import QuickActionsDynamicCard from './QuickActionsDynamicCard';
// import QuickActionsChecklist from './QuickActionsChecklist';
import QuickActionsWrapper from './QuickActionsWrapper';
// import quickActionsGif from '../../assets/images/kycWidgetGif.gif';
import Loader from '../../components/Loader';
import WelcomeModals from './WelcomeModals';
import * as Actions from '../../store/actions';
import TourMenu from './TourMenu';
import {
  QuickActionsTopup,
  QuickActionsLookup,
  QuickActionsOnboard,
  // Unchecked,
  // Checked,
} from '../../components/images';
import {PageContext} from '../../helpers/context';
import {
  formatNumberToCurrency,
  formatUsd,
} from '../../helpers/formatNumberToCurrency';
import {PrimaryButton, SecondaryButton, TopupModal} from '../../components';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';

function QuickActions({auth: {userDetails, loading, user}, updateUserProfile}) {
  const [openWelcomeModals, setOpenWelcomeModals] = useState(false);
  const [openTopUp, setOpenTopUp] = useState(false);
  const [openTour, setOpenTour] = useState(false);
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('quickactions');
  }, [setPageName]);

  // const hasCompletedChecklist = useMemo(() => {
  //   const updatedUserDetails = userDetails || {};
  //   const updatedChecklist =
  //     updatedUserDetails.checklist &&
  //     Object.keys(updatedUserDetails.checklist).reduce((acc, key) => {
  //       if (key !== 'verification') {
  //         acc[key] = updatedUserDetails.checklist[key];
  //       }
  //       return acc;
  //     }, {});
  //   const updatedDetails = {
  //     ...updatedUserDetails,
  //     checklist: updatedChecklist,
  //   };
  //   return (
  //     updatedDetails &&
  //     updatedDetails.checklist &&
  //     Object.values(updatedDetails.checklist).every(check => check)
  //   );
  // }, [userDetails]);

  const permittedLinks = useCallback(
    (permissions = {}) => {
      if (userDetails?.permissions?.role !== 'Owner') {
        return Object.values(permissions).some(value => value);
      }
      return true;
    },
    [userDetails],
  );

  useEffect(() => {
    if (user?.first_time_user) setOpenWelcomeModals(true);
  }, [user]);

  const disableLookup = !permittedLinks(
    userDetails?.permissions?.lookupPermissions,
  );

  const manageOnboardFlows =
    userDetails?.permissions?.onboardPermissions?.manageFlows;
  const viewOnboardFlows =
    userDetails?.permissions?.onboardPermissions?.viewFlows;
  const topUpPermissions =
    userDetails?.permissions?.quickActionPermissions?.topup;

  const disableOnboard = !manageOnboardFlows && !viewOnboardFlows;

  const isSubdomain = !!localStorage.subdomain;

  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 96);

  return (
    <>
      <QuickActionsWrapper
        topup={
          userDetails?.checklist?.topup && topUpPermissions ? (
            <div className="items-center hidden gap-4 sm:flex">
              <span
                data-testid="wallet-balance"
                className="text-small font-medium text-[#858DAA]"
              >
                Wallet Balance:{' '}
                {userDetails &&
                userDetails?.company &&
                userDetails?.company?.currency === 'USD'
                  ? formatUsd(userDetails?.company?.wallet_balance / 100 ?? 0)
                  : formatNumberToCurrency(
                      userDetails?.company?.wallet_balance / 100 ?? 0,
                      userDetails &&
                        userDetails.company &&
                        userDetails.company.currency,
                    )}
              </span>
              <PrimaryButton
                buttonText="Quick Top-up"
                onClick={() => setOpenTopUp(!openTopUp)}
                className="text-xs"
              />
            </div>
          ) : null
        }
      >
        <TopupModal open={openTopUp} setOpen={setOpenTopUp} />

        <WelcomeModals
          closeModal={() => setOpenWelcomeModals(false)}
          open={openWelcomeModals}
          setOpen={setOpenWelcomeModals}
          updateUserProfile={updateUserProfile}
        />
        <TourMenu open={openTour} setOpen={setOpenTour} />
        {loading ? (
          <Loader height={80} />
        ) : (
          <div className="flex flex-col gap-8 sm:gap-6 pl-4 lg:pl-0">
            <div className="grid grid-cols-1 lg:grid-cols-3">
              <QuickActionsCard
                imageComponent={<QuickActionsTopup />}
                heading="AML Screening"
                paragraph="Screen users against global watchlists."
                linkText="Perform a Search"
                link="/aml-screening/v2"
                className="lg:rounded-l-2xl rounded-t-2xl lg:rounded-r-none"
              />

              <QuickActionsCard
                imageComponent={<QuickActionsLookup />}
                heading="Government Lookup"
                paragraph="Perform multiple identity lookup with ease."
                linkText="Perform a Lookup"
                link={
                  permittedLinks(userDetails?.permissions?.lookupPermissions)
                    ? '/easy-lookup/individual'
                    : '/quick-actions'
                }
                disabled={
                  userDetails?.permissions?.role === 'Owner'
                    ? undefined
                    : disableLookup
                }
              />
              <QuickActionsCard
                imageComponent={<QuickActionsOnboard />}
                heading="Easy Onboard"
                paragraph="Create onboarding flows to verify the identity of your users."
                linkText="Create a flow"
                link={
                  permittedLinks(userDetails?.permissions?.onboardPermissions)
                    ? '/easy-onboard'
                    : '/quick-actions'
                }
                disabled={
                  userDetails?.permissions?.role === 'Owner'
                    ? undefined
                    : disableOnboard
                }
                className="lg:rounded-r-2xl rounded-b-2xl lg:rounded-l-none"
              />
            </div>
            <div className="-mx-20 py-8">
              <div className="mx-20 lg:mx-[147px]">
                {!isSubdomain && (
                  <QuickActionsDynamicCard lighterShade={lighterShade} />
                )}
              </div>
            </div>

            <div className="-mx-20 py-8">
              <div className="mx-[80px]">
                <h2 className="text-[18px] mb-6 text-deepBlue font-semibold">
                  User Guides & Help Centre
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {[
                    {
                      title: 'Documentation',
                      description:
                        'Comprehensive guides to assist you in configuring and effectively using our platform.',
                      buttonText: 'Read Documentation',
                      link: 'https://api-docs.dojah.io/docs/getting-started',
                    },
                    {
                      title: 'FAQs',
                      description:
                        'Quick answers to frequently asked questions for clarification.',
                      buttonText: 'Go to FAQs',
                      link: 'https://support.dojah.io/en/',
                    },
                    {
                      title: 'Changelogs',
                      description:
                        'Stay updated on new features, fixes, and improvements.',
                      buttonText: 'View Changelogs',
                      link: 'https://api-docs.dojah.io/changelog/api_changes',
                    },
                    {
                      title: 'Resources',
                      description:
                        'In-depth insights and industry analyses to guide your compliance and growth strategies.',
                      buttonText: 'Read Resources',
                      link: 'https://dojah.io/resources',
                    },
                  ].map((guide, index) => (
                    <div
                      key={index}
                      style={{
                        backgroundColor: lighterShade,
                        borderColor: 'rgba(230, 240, 255, 0.5)',
                      }}
                      className="w-full gap-4 lg:gap-0 flex flex-col lg:flex-row items-start lg:items-center justify-between rounded-xl border-[0.5px] shadow-cards py-4 px-6"
                    >
                      <div className="flex flex-col max-w-[275px] gap-2">
                        <h3 className="text-tiny font-semibold text-deepBlue">
                          {guide.title}
                        </h3>
                        <p className="text-body font-normal text-small">
                          {guide.description}
                        </p>
                      </div>
                      <SecondaryButton
                        className="!h-fit"
                        buttonText={guide.buttonText}
                        onClick={() => window.open(guide.link, '_blank')}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* <div className="flex flex-col gap-6 lg:flex-row sm:gap-4 basis-full">
              {hasCompletedChecklist ? (
                <div className="py-6 px-4 lg:px-8 md:py-[21px] bg-white rounded basis-[67.2%]">
                  <div className="flex flex-wrap sm:flex-nowrap items-center gap-8 justify-center sm:justify-start h-full">
                    <div className="">
                      <h4 className="text-base text-body font-medium">
                        Quick tour
                      </h4>
                      <p className="mt-6 text-grey text-lg font-medium">
                        Take a Quick Tour
                      </p>
                      <p className="mt-2 text-sm text-body">
                        Take a quick tour of our features to help you easily
                        navigate the application and sign up real users fast
                      </p>

                      <button
                        className="inline-block mt-4 text-brandBlue text-sm font-medium p-4"
                        onClick={() => setOpenTour(true)}
                      >
                        View tour
                      </button>
                    </div>

                    <div className="aspect-square w-full">
                      <img src={quickActionsGif} alt="" />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="px-4 py-8 lg:p-8 bg-white rounded basis-[67.2%]">
                  <div className="flex items-center justify-between">
                    <h4 className="text-base font-medium text-grey">
                      Checklist
                    </h4>
                  </div>

                  <div className="flex flex-col gap-6 mt-6 w-fit">
                    <QuickActionsChecklist
                      imageComponent={<Checked />}
                      heading="Sign Up"
                      paragraph="Sign up to start verifying identities."
                    />
                    <QuickActionsChecklist
                      imageComponent={
                        userDetails?.checklist?.topup ? (
                          <Checked />
                        ) : (
                          <Unchecked />
                        )
                      }
                      heading="Top-up wallet"
                      paragraph="Add money to your wallet to start making API calls."
                      link={
                        userDetails?.permissions?.role === 'Owner'
                          ? Constants.PAGES_URL.SETTINGS_BILLING
                          : '/quick-actions'
                      }
                    />
                    <QuickActionsChecklist
                      imageComponent={
                        userDetails?.checklist?.createApp ? (
                          <Checked />
                        ) : (
                          <Unchecked />
                        )
                      }
                      heading="Create an app"
                      paragraph="API calls are attached to apps, create an app to successfully call an API."
                      link={
                        permittedLinks(userDetails?.permissions?.appPermissions)
                          ? Constants.PAGES_URL.DEVELOPERS_CONFIGURATION
                          : '/quick-actions'
                      }
                    />
                    <QuickActionsChecklist
                      imageComponent={
                        userDetails?.checklist?.idCheck ? (
                          <Checked />
                        ) : (
                          <Unchecked />
                        )
                      }
                      heading="Perform an Identity check"
                      paragraph="LookUp an identity."
                      link={
                        permittedLinks(
                          userDetails?.permissions?.lookupPermissions,
                        )
                          ? Constants.PAGES_URL.INDIVIDUAL_LOOKUP_SINGLE
                          : '/quick-actions'
                      }
                    />
                  </div>
                </div>
              )}
            </div> */}
          </div>
        )}
      </QuickActionsWrapper>
    </>
  );
}

export default connect(state => state, Actions)(QuickActions);
